





















































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

export default Vue.extend({
  name: "RegisterCard",
  components: {},
  data(): any {
    return {
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        confirmPassword: null,
      },
    };
  },
  created() {
    if (this.$route.query.email) {
      this.form.email = this.$route.query.email;
    }
  },
  computed: {
    ...mapGetters("auth", {
      loading: "getLoading",
    }),
  },
  methods: {
    ...mapActions("auth", ["createAuthUser"]),
    onRegister() {
      const payload = {
        ...this.form,
        token: this.$route.query.token,
      };
      this.createAuthUser(payload);
    },
  },
});
